import React from 'react';
import { Link } from 'react-router-dom';
import { IOS_APP_URL, ANDROID_APP_URL } from '../../storeLinks';

function FooterHomeOne({ className }) {
    return (
        <>
            <section className={`dd-footer-area ${className || ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="footer-about-widget">
                                <div className="logo">
                                    <Link to="/">
                                        <span className="dd-logo-red" role="img" aria-label="Drive.Day" />
                                    </Link>
                                </div>
                                <p>
                                    The all-in-one app for driving instructors and driving schools:
                                    your diary, pupils, lessons, payments and team in one place.
                                </p>
                                <Link to="/about-us">
                                    About Drive.Day <i className="fa-jelly-fill fa-regular fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-navigation">
                                <h4 className="title">Product</h4>
                                <ul>
                                    <li>
                                        <Link to="/#features">Features</Link>
                                    </li>
                                    <li>
                                        <Link to="/#school">School management</Link>
                                    </li>
                                    <li>
                                        <Link to="/pupil-app">Pupil app</Link>
                                    </li>
                                    <li>
                                        <Link to="/#pricing">Pricing</Link>
                                    </li>
                                    <li>
                                        <Link to="/#faq">FAQs</Link>
                                    </li>
                                    <li>
                                        <Link to="/#download">Download</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-navigation">
                                <h4 className="title">Company</h4>
                                <ul>
                                    <li>
                                        <Link to="/about-us">About Us</Link>
                                    </li>
                                    {/* Blog hidden for now
                                    <li>
                                        <Link to="/news">Blog</Link>
                                    </li> */}
                                    <li>
                                        <Link to="/contact">Contact</Link>
                                    </li>
                                    <li>
                                        <Link to="/privacy-policy">Privacy Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/terms-of-service">Terms of Service</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="footer-copyright d-flex align-items-center justify-content-between pt-35">
                                <div className="apps-download-btn">
                                    <ul>
                                        <li>
                                            <a href={IOS_APP_URL}>
                                                <i className="fab fa-apple" /> Download for iOS
                                            </a>
                                        </li>
                                        <li>
                                            <a className="item-2" href={ANDROID_APP_URL}>
                                                <i className="fab fa-google-play" /> Download for
                                                Android
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="copyright-text">
                                    <p>&copy; {new Date().getFullYear()} DayBadger LTD. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default FooterHomeOne;
